import { NotificationItem, NotificationPayload } from "../../../store/slices/NotificationsSlice";

// firstName/lastName may be null when the user can't be resolved — fall back gracefully.
export const getNotificationUserName = (notification: NotificationItem): string => {
  const fullName = [notification.firstName, notification.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return fullName || "Unknown user";
};

// insightType is the human-readable type; fall back to the stable ruleKey, then a dash.
export const getNotificationType = (notification: NotificationItem): string =>
  notification.insightType || notification.ruleKey || "—";

export const formatDateTime = (value?: string | null): string => {
  if (!value) return "—";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

// payload is an open JSON blob; read the human-readable message defensively
// rather than hard-coding deep paths that only exist for some insight types.
export const getPayloadMessage = (
  payload?: NotificationPayload | null
): { title?: string; body?: string } => {
  if (!payload || typeof payload !== "object") return {};
  const message = payload.message;
  if (!message || typeof message !== "object") return {};
  return {
    title: typeof message.title === "string" ? message.title : undefined,
    body: typeof message.body === "string" ? message.body : undefined,
  };
};

export const stringifyPayload = (payload?: NotificationPayload | null): string => {
  try {
    return JSON.stringify(payload ?? {}, null, 2);
  } catch {
    return "Unable to display payload.";
  }
};
